import React from "react";
import { EmojiPicker } from "frimousse";

function MyEmojiPicker({ onSelect }) {
  return (
    <div
      style={{
        position: "absolute",
        top: "45px",
        left: 0,
        zIndex: 1000,
        background: "#fff",
        border: "1px solid rgba(2,6,23,.10)",
        borderRadius: 12,
        boxShadow: "0 18px 40px rgba(2,6,23,.16)",
        overflow: "hidden",
      }}
    >
      <EmojiPicker.Root
        style={{
          width: 320,
          height: 360,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <EmojiPicker.Search
          placeholder="Search emoji..."
          style={{
            margin: 8,
            height: 38,
            borderRadius: 8,
            border: "1px solid #e2e8f0",
            padding: "0 10px",
            fontSize: 14,
          }}
        />

        <EmojiPicker.Viewport style={{ flex: 1, overflow: "auto" }}>
          <EmojiPicker.Loading
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              color: "#64748b",
            }}
          >
            Loading…
          </EmojiPicker.Loading>

          <EmojiPicker.Empty
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              color: "#64748b",
            }}
          >
            No emoji found
          </EmojiPicker.Empty>
            <EmojiPicker.List
            style={{
                padding: 8,
            }}
            components={{
                Emoji: ({ emoji, ...props }) => (

                <button
                  {...props}
                    type="button"
                    style={{
                    width: 36,
                    height: 36,
                    fontSize: 20,
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    borderRadius: 8,
                    }}

                  onClick={(e) => {
                    props.onClick?.(e);
                    onSelect?.(emoji.emoji);
                  }}
                >
                  {emoji.emoji}
                </button>
              ),
            }}
          />
        </EmojiPicker.Viewport>
      </EmojiPicker.Root>
    </div>
  );
}

export default MyEmojiPicker;
